export const checkoutInitialValues = {
  name: '',
  cellphone: '',
  location: '',
  address: '',
};
